// src/pages/auth/Login.tsx
import React from 'react'
import { Navigate } from 'react-router-dom'

import { Card } from '@/components/common'
import { LoginForm } from '@/features/auth/components/LoginForm/LoginForm'
import { useAuth } from '@/hooks/useAuth'

export const LoginPage: React.FC = () => {
  const { isAuthenticated } = useAuth()

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div className=" flex items-center justify-center bg-gradient-to-br from-primary-50 to-secondary-50 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <p className="mt-1 text-sm text-gray-600">Inicia sesión para continuar</p>
        </div>

        <Card className="shadow-medium">
          <LoginForm />
        </Card>
      </div>
    </div>
  )
}
